import SectionHeader from '../../components/ui/section-header'
import JoinedRewards from '../../components/rewards-hub/joined-rewards'
import ParticipatingBrands from '../../components/rewards-hub/participating-brands'
import { useQuery } from '@tanstack/react-query';
import apiClient from '../../api/client';
import { Link } from 'react-router-dom';
import ImageWithFallback from '../../components/ImageWithFallback';

type EntitySummary = {
  entity_id: string;
  entity_name: string | null;
  entity_logo_image: string | null;
};

type GetRewardBrandsResponse = {
  success: boolean;
  message: string;
  data: EntitySummary[];
  statusCode: number;
};

export default function MyRewardsHub() {

  const { data: rewardsData } = useQuery<GetRewardBrandsResponse>({
    queryKey: ["getRewardBrands"],
    queryFn: async () => {
      const resp = await apiClient.get('/reward-brands');
      return resp.data;
    },
  });

  const { data: participatingRewardsData } = useQuery<GetRewardBrandsResponse>({
    queryKey: ["getParticipatingBrands"],
    queryFn: async () => {
      const resp = await apiClient.get('reward/participating-brands');
      return resp.data || {};
    },
  });

  const rewards = rewardsData?.data || [];
  const participatingRewards = participatingRewardsData?.data || [];

  return (
    <section className="flex flex-col gap-y-4">
      <SectionHeader
        href={'/'}
        title={<>
          <h1 className="text-md md:text-lg font-bold leading-6 text-gray-900">
            My Rewards Hub
          </h1>
        </>}
      />

      <div className='flex flex-col gap-y-4 px-6'>
        {rewards.length > 0 && (
          <>
            <h3 className="mx-4 text-lg font-normal">My Joined Rewards</h3>

            <div className="grid grid-cols-5 gap-y-4 md:grid-cols-5 md:gap-x-4">
              {rewards.map(entity => (
                <Link
                  to={`/my-rewards-hub/${entity.entity_id}`}
                  className="flex flex-col md:flex-row md:justify-start justify-center items-center gap-y-2 md:gap-x-4"
                >
                  <div className='size-14 md:size-20 shadow-lg rounded-2xl bg-white p-2'>
                    <ImageWithFallback
                      src={entity?.entity_logo_image || ''}
                      alt={entity?.entity_name || ''}
                      className='size-full object-contain'
                    />
                  </div>
                  <p className='text-xs md:text-base font-normal line-clamp-1 md:line-clamp-none md:w-[calc(100%-6rem)]'>
                    {entity.entity_name}
                  </p>
                </Link>
              ))}
            </div>
          </>
        )}

        <h3 className="mx-4 text-lg font-normal">Participating Brands</h3>

        <div className="grid grid-cols-5 gap-y-4 md:grid-cols-5 md:gap-x-4">
          {participatingRewards.map(entity => (
            <Link
              to={`/my-rewards-hub/${entity.entity_id}`}
              className="flex flex-col md:flex-row md:justify-start justify-center items-center gap-y-2 md:gap-x-4"
            >
              <div className='size-14 md:size-20 shadow-lg rounded-2xl bg-white'>
                <ImageWithFallback
                  src={entity?.entity_logo_image || ''}
                  alt={entity?.entity_name || ''}
                  className='size-full object-contain'
                />
              </div>
              <p className='text-xs md:text-base font-normal line-clamp-1 md:line-clamp-none md:w-[calc(100%-6rem)]'>
                {entity.entity_name}
              </p>
            </Link>
          ))}
        </div>
      </div>


    </section>
  )
}